<!--
 * @Author: wangwei
 * @Date: 2020-12-29 15:56:16
 * @LastEditTime: 2022-05-25 13:53:44
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: 订单支付页面
 * @FilePath: /java-pc/src/views/buy/pay.vue
-->
<template>
    <div id="pay">
        <div class="top_info">
            <div class="top_info_header">
                <div class="top_logo">
                    <div :style="`background-image:url(${configInfo.main_site_logo})`" :onerror='defaultImg'></div>
                </div>
                <div class="top_info_progress flex_row_end_center">

                    <div class="progress_item" v-if="ifcart=='true'">
                        <div class="progress flex_row_center_center">
                            <span class="active">1</span>
                            <div class="progress_line">
                                <div :class="{content:true,active:true}"></div>
                            </div>
                        </div>
                        <p>购物车</p>
                    </div>

                    <div class="progress_item">
                        <div class="progress flex_row_center_center">
                            <span class="active">{{ifcart=='true'?2:1}}</span>
                            <div class="progress_line">
                                <div :class="{content:true,active:true,current:false}"></div>
                            </div>
                        </div>
                        <p style="margin-left: -11px">确认订单</p>
                    </div>

                    <div class="progress_item">
                        <div class="progress flex_row_center_center">
                            <span class="active">{{ifcart=='true'?3:2}}</span>
                            <div class="progress_line">
                                <div :class="{content:true,active:payComplete}"></div>
                            </div>
                        </div>
                        <p>付款</p>
                    </div>

                    <div class="progress_item" style="margin-left: -24px">
                        <div class="progress flex_row_end_center">
                            <span :class="{active:payComplete}">{{ifcart=='true'?4:3}}</span>
                        </div>
                        <p>支付成功</p>
                    </div>

                </div>
            </div>
            <div class="top_info_text flex_row_between_between">
                <span>订单提交成功，请您尽快付款！ 订单号： {{pay_info.data.paySn}}</span>
                <div class="price">
                    应付金额
                    <span>{{pay_info.data.needPay}}</span> 元
                </div>
            </div>
            <div class="top_info_text flex_row_between_between">
                <span>
                    请您在提交订单后
                    <span>72小时内</span>完成支付，否则订单会自动取消
                </span>

                <div class="show_detail pointer" @click="showDetail">{{show_all_details?'收起详情':'展开详情'}}</div>
            </div>
          <div class="top_info_text flex_row_between_between" v-if="route.query.unifiedOrder !== '1' && store.state.memberInfo.multipleStoresId > 0">
                  <span class="red-text">
                    如果订单需要其他门店合并支付，请选择下方的多单合并选项并点击确认
                </span>
          </div>
            <div class="receive_info">
                <div v-for="(member, index) in pay_info.data.memberInfoList" :key="index">
                    <div v-if="index === 0 || show_all_details">
                        <p>
                            收货地址：{{member.receiveAddress}}
                            收货人：{{member.receiverName}}
                            {{member.receiverMobile}}
                        </p>
                        <p>商品名称：{{member.goodsNameList.join(' , ')}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg">
            <div class="pay_method" v-if="hasPayMethod">
                <div v-if="!show_wx_pay">
                    <div class="balance" v-if="balance_list.data.length>0">
                      <div class="logo" >{{ store.state.memberInfo.multipleStoresId > 0 && route.query.unifiedOrder === "1" ? '余额支付' : '余额支付' }}</div>
                        <div class="balance_info">
                            <i :class="{iconfont:true, 'icon-yuanquan1':(pay_info.data.availableCreditLine>0 ||pay_info.data.balanceAvailable > 0)&&(pay_info.data.needPay<=(pay_info.data.balanceAvailable+ pay_info.data.availableCreditLine)) ,'icon-duihao1':current_pay_method.data.payMethod==balance_list.data[0].payMethod,'icon-jinzhi1':(pay_info.data.availableCreditLine <= 0 && pay_info.data.balanceAvailable <=0)||(pay_info.data.needPay> (pay_info.data.balanceAvailable+ pay_info.data.availableCreditLine))}"
                                @click="pay_info.data.availableCreditLine>pay_info.data.needPay ||pay_info.data.balanceAvailable > pay_info.data.needPay || (pay_info.data.needPay<=(pay_info.data.balanceAvailable+ pay_info.data.availableCreditLine)) ?showConfirmDialog(balance_list.data[0]):''"></i>
                          <span class="weight big_size">{{store.state.memberInfo.multipleStoresId > 0 && route.query.unifiedOrder === "1" ? '余额支付' : '余额支付'}}</span>
                            <span class="avai">
                                （可用余额：
                                <span class="weight">{{pay_info.data.balanceAvailable}}</span>元，
                                可用授信额度：<span class="weight">{{pay_info.data.availableCreditLine}}元</span>，
                                目前需要在线支付：
                                <span class="weight">{{pay_info.data.needPay}}</span>元）余额不足？
                                <span class="weight pointer" @click="goRecharge" style="color:#168ED8">马上充值</span>
                            </span>
                        </div>
                        <div class="password" v-if="current_pay_method.data.payMethod==balance_list.data[0].payMethod">
                            <el-input class="password_input" placeholder="支付密码" v-model="password" show-password>
                            </el-input>
                            <p v-if="!memberInfo.hasPayPassword">
                                <span style="color: #FFB33A;"><i class="el-icon-warning"></i>未设置支付密码，马上去设置</span>
                                <router-link class="set_password pointer" :to="'/member/pwd/pay'">设置密码</router-link>
                            </p>
                            <p v-else>
                                <span class="forget_password pointer" @click="forgetPassword">忘记密码?</span>
                            </p>
                        </div>
                    </div>
                    <div class="balance other_pay_method" v-if="other_pay_list.data.length>0">
                        <div class="logos">其他支付</div>
                        <div class="balance_info flex">
                            <div :class="{other_pay_item:true, flex_row_around_center:true,wechat:index!=0}"
                                v-for="(item,index) in other_pay_list.data" :key="index" @click="showConfirmDialog(item)">
                                <i
                                    :class="{iconfont:true, 'icon-yuanquan1':current_pay_method.data.payMethod!=item.payMethod,'icon-duihao1':current_pay_method.data.payMethod==item.payMethod}"></i>
                                <!-- 图标放置的位置-->
                                <img :src="item.payMethod=='alipay'?ali:item.payMethod=='wx'?wechat:item.payMethod=='wlian'?wlian:item.payMethod=='unified'?unified:yinlian" alt />
                                <span>{{item.payMethodName}}</span>
                            </div>
                        </div>
                        <div v-if="!is_show"  class="password">
                            <div>请以贵公司抬头为户名的银行账户按订单金额向以下收款账户转账</div>
                            <div>账户名：西藏仟源药业有限公司</div>
                            <div>开户行：民生上海曹杨支行</div>
                            <div> 银行账户：630936640</div>
                            <div> 当贵公司转账款到账后1小时内，订单将由“待支付”状态变为“待发货”；如要取消订单，请在“待支付”订单中找到该订单并点选“取消订单”</div>
                        </div>
                        <div v-if="wx_show"  class="password">
                            <div> 请通过贵公司的企业微信账户支付订单，不接受个人微信账户支付。</div>
                        </div>
                        <div v-if="zfb_show"  class="password">
                            <div> 请通过贵公司的企业支付宝账户支付订单，不接受个人支付宝账户支付。</div>
                        </div>
                      <div v-if="unified_show"  class="password">
                        <div> 您当前选择了多单合并，点击确认后您的订单将进入等待多单合并状态。后续可在“个人中心”或“我的订单”页面，点击“合并支付”，与其他门店订单一并完成付款。</div>
                      </div>
                    </div>
                    <div v-if="is_show && !unified_show" class="pay" @click="pay()" style="cursor: pointer;">立即支付</div>
                    <div v-else-if="!unified_show" class="pay" @click="pay()" style="cursor: pointer">确认</div>
                    <div v-else class="pay" @click="pay()" style="cursor: pointer">确认</div>
                </div>
                <div class="wx_pay_con" v-if="show_wx_pay">
                    <p class="title" @click="hideWxPay">
                        <i class="iconfont icon-ziyuan2"></i>
                        <span>选择其它支付方式</span>
                    </p>
                    <div class="qr flex_row_around_center">
                        <div class="left flex_column_start_center">
                            <img :src="wxPayQrImg" />
                            <p>
                                使用
                                <span>微信支付</span>APP
                            </p>
                            <p>扫码完成支付</p>
                            <div class="refresh" @click="refreshWxQrcode">刷新</div>
                        </div>
                        <img class="wx_png" :src="wx_pay_tip" />
                    </div>
                </div>
            </div>
            <div class="no_payMethod" v-else>
                <img src="@/assets/member/member_empty.png" alt="">
                <p>暂无可用的支付方式，平台正在紧急处理中～</p>
            </div>

            <!-- 自定义支付确认对话框 -->
            <el-dialog
              v-model="showPaymentConfirmDialog"
              title="确认订单"
              width="400px"
              center>
              <div class="confirm-content">
                <!-- 根据支付方式显示不同的提示文本 -->
                <p class="confirm-message" v-if="selectedPaymentMethod && selectedPaymentMethod.payMethod === 'balance'" style="text-align: center; font-size: 16px; margin: 0 0 10px 0;">请输入您的支付密码，然后点击提交按钮</p>
                <p class="confirm-message" v-else style="text-align: center; font-size: 16px; margin: 0 0 10px 0;">是否立即提交订单</p>

                <!-- 仅在余额支付时显示密码输入框 -->
                <div v-if="selectedPaymentMethod && selectedPaymentMethod.payMethod === 'balance'" class="balance-password-section" style="margin-top: 5px;">
                  <el-input
                    class="password_input"
                    placeholder="支付密码"
                    v-model="dialogPassword"
                    show-password>
                  </el-input>
                  <p v-if="!memberInfo.hasPayPassword" style="margin-top: 5px;">
                    <span style="color: #FFB33A;"><i class="el-icon-warning"></i>未设置支付密码，马上去设置</span>
                    <router-link class="set_password pointer" :to="'/member/pwd/pay'">设置密码</router-link>
                  </p>
                </div>
              </div>

              <template #footer>
                <span class="dialog-footer" style="display: flex; gap: 10px; width: 100%; justify-content: center; margin-top: -10px;">
                  <el-button @click="cancelPaymentSelection">重选</el-button>
                  <el-button type="primary" @click="confirmPaymentSelection">提交</el-button>
                </span>
              </template>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { reactive, getCurrentInstance, ref, onMounted, onUnmounted } from "vue";
    import { ElMessage, ElInput, ElMessageBox, ElDialog, ElButton } from "element-plus";
    import { useRoute, useRouter } from "vue-router";
    import { useStore } from "vuex";
    export default {
        name: "Pay",
        components: {
            ElInput
        },
        setup() {
            const ifcart = ref('')
            const yinlian = require("../../assets/buy/yinlian.png")
            const balance = require("../../assets/buy/balance.png");
            const otherPay = require("../../assets/buy/otherPay.png");
            const ali = require("../../assets/buy/ali.png");
            const unified = require("../../assets/buy/unified.png");
            const wechat = require("../../assets/buy/wechat.png");
            const wlian = require("../../assets/buy/wlian.png");
            const wx_pay_tip = require("../../assets/buy/wx_pay_tip.png");
            const route = useRoute();
            const router = useRouter();
            const store = useStore()
            const is_show = ref(true)
            const { proxy } = getCurrentInstance();
            const pay_method = reactive({ data: [] });
            const pay_info = reactive({ data: {} });
            const paySn = ref("");
            const current_pay_method = reactive({ data: {} });
            const balance_list = reactive({ data: [] });
            const other_pay_list = reactive({ data: [] });
            const buy_name_list = ref("");
            const password = ref("");
            const show_wx_pay = ref(false);
            const wxPayQrImg = ref('');//微信支付二维码
            const timer = ref(0);//定时器
            const show_detail = ref(false)
            const show_all_details = ref(false)
            const hasPayMethod = ref(true)
            const zfb_show = ref(false)
            const unified_show = ref(false)
            const wx_show = ref(false)
            const configInfo = ref(store.state.configInfo)
            const memberInfo = ref(store.state.memberInfo);
            const defaultImg = ref('this.src="' + require('../../assets/common_top_logo.png') + '"')

            // 新增用于支付确认对话框的响应式变量
            const showPaymentConfirmDialog = ref(false);
            const selectedPaymentMethod = ref(null);
            const dialogPassword = ref('');
            //获取支付方式
            const getPayMethod = () => {
                proxy
                    .$get("v3/business/front/orderPay/payMethod", {
                        multipleStoresId: store.state.memberInfo.multipleStoresId,
                        unifiedOrder: route.query.unifiedOrder,
                        source: "pc",
                        type: 1
                    })
                    .then(res => {
                        if (res.state == 200) {
                            hasPayMethod.value = res.data.length > 0 ? true : false
                            res.data.map(item => {
                                if (item.payMethod == "balance") {
                                    balance_list.data.push(item);
                                } else {
                                    other_pay_list.data.push(item);
                                }
                            });
                            //other_pay_list.data = other_pay_list.data.filter(item => item.payType != 'BANK') //后加的去除线下支付方式
                        } else {
                            ElMessage(res.msg);
                        }
                    })
                    .catch(() => {
                        //异常处理
                    });
            };
            //获取订单支付数据
            const getPayInfo = () => {
                proxy
                    .$get("v3/business/front/orderPay/payInfo", {
                        unifiedOrder: route.query.unifiedOrder,
                        paySn: route.query.paySn,
                        payFrom: route.query.payFrom
                    })
                    .then(res => {
                        if (res.state == 200) {
                            pay_info.data = res.data;
                            // 处理新的 memberInfoList 数据结构
                            if (res.data.memberInfoList && res.data.memberInfoList.length > 0) {
                                let allGoodsNames = [];
                                res.data.memberInfoList.forEach(member => {
                                    if (member.goodsNameList && member.goodsNameList.length > 0) {
                                        allGoodsNames = allGoodsNames.concat(member.goodsNameList);
                                    }
                                });
                                buy_name_list.value = [...new Set(allGoodsNames)].join(" + "); // 使用 Set 去重
                            }
                            console.log(pay_info.data)    //20211215
                        } else if (res.state == 267) {
                            ElMessage.success(res.msg + ',2s后自动跳转订单列表');
                            //清除定时器
                            if (timer.value) {
                                clearInterval(timer.value);
                                timer.value = 0;
                            }
                            setTimeout(() => {
                                router.replace({
                                    path: '/member/order/list',
                                });
                            }, 2000)
                        } else {
                            ElMessage(res.msg);
                        }
                    })
                    .catch(() => {
                        //异常处理
                    });
            };
            const changePayMethod = pay_method => {
                current_pay_method.data = pay_method;
                is_show.value=true;
                unified_show.value = false;
                zfb_show.value = false;
                wx_show.value = false;
                if(pay_method.payMethodName==='线下支付'){
                    is_show.value=false;
                }else if (pay_method.payMethodName==='线下合并支付'){
                    is_show.value=false;
                }else if (pay_method.payMethodName==='微信支付'){
                    wx_show.value = true;
                }else if (pay_method.payMethodName==='支付宝'){
                    zfb_show.value = true;
                }else if (pay_method.payMethodName==='多单合并'){
                    unified_show.value = true;
                }
            };
            //去支付
            const payComplete = ref(false)
            const pay = (fromDialog = false) => {
                // 验证是否选择了支付方式
                if (!current_pay_method.data.payMethod) {
                    ElMessage.warning("请选择支付方式");
                    return Promise.resolve(false); // 返回失败状态
                }

                let param = {};
                param.payType = current_pay_method.data.payType;
                param.payMethod = current_pay_method.data.payMethod;
                param.paySn = pay_info.data.paySn;

                //余额支付
                if (param.payMethod == 'balance') {
                    if (password.value == "") {
                        ElMessage.warning("请输入支付密码");
                        return Promise.resolve(false); // 返回失败状态
                    }
                    param.payPwd = password.value; //支付密码,使用余额时必传
                }

                //请求支付接口
                return proxy.$post("v3/business/front/orderPay/doPay", param).then(res => {
                    if (res.state == 200) {
                        if (param.payMethod == 'balance') {
                            ElMessage.success('支付成功,2s后自动跳转订单列表');
                            payComplete.value = true
                            //清除定时器
                            setTimeout(() => {
                                router.replace({
                                    path: '/member/order/list',
                                });
                            }, 2000)
                        } else if (param.payMethod == 'alipay') {
                            document.write(res.data.payData);//自动提交表单数据
                        } else if (param.payMethod == 'wx') {
                            show_wx_pay.value = true;
                            wxPayQrImg.value = 'data:image/png;base64,' + res.data.payData;//微信支付二维码
                            // 定时查询是否支付成功
                            timer.value = setInterval(() => {
                                queryPayState();
                            }, 3000)
                            //两小时自动跳转订单列表
                            setTimeout(() => {
                                router.replace({
                                    path: '/member/order/list',
                                });
                            }, 432000000);
                        }else if (param.payMethod == 'wlian') {
                          window.location.href = res.data.payData;
                        }else if (param.payMethod == 'offline'){

                            payComplete.value = true
                            //清除定时器
                            setTimeout(() => {
                                router.replace({
                                    path: '/member/order/list',
                                });
                            }, 4000)
                        }else if (param.payMethod == 'unified'){
                          ElMessage.success('提交成功,2s后自动跳转订单列表');
                          payComplete.value = true
                          //清除定时器
                          setTimeout(() => {
                            router.replace({
                              path: '/member/order/list',
                            });
                          }, 2000)
                        }
                        return Promise.resolve(true); // 返回成功状态
                    } else {
                        ElMessage(res.msg);
                        // 如果是从对话框发起的支付，且支付失败，不关闭对话框
                        if (fromDialog) {
                            // 保持对话框开启，允许用户重试
                        }
                        return Promise.resolve(false); // 返回失败状态
                    }
                })
                    .catch((error) => {
                        //异常处理
                        ElMessage.error('支付失败，请重试');
                        // 如果是从对话框发起的支付，且支付失败，不关闭对话框
                        if (fromDialog) {
                            // 保持对话框开启，允许用户重试
                        }
                        return Promise.reject(error);
                    });
            };
            // 定时查询是否支付成功
            const queryPayState = () => {
                getPayInfo();
            }
            //隐藏微信支付内容
            const hideWxPay = () => {
                show_wx_pay.value = false;
            };
            //刷新微信支付二维码
            const refreshWxQrcode = () => {
                pay();
            };
            //收起展开详情
            const showDetail = () => {
                show_all_details.value = !show_all_details.value
            }
            onMounted(() => {
                paySn.value = route.query.paySn;
                ifcart.value = route.query.ifcart
                getPayMethod();
                getPayInfo();
                console.log(paySn.value)
            });
            const goRecharge = () => {
                router.push('/member/recharge')
            }
            const forgetPassword = () => {
                router.push('/member/pwd/reset')
            }

            // 显示支付确认对话框
            const showConfirmDialog = (pay_method) => {
                // 在显示新对话框前，确保清空之前的密码
                dialogPassword.value = '';

                selectedPaymentMethod.value = pay_method;

                // 如果是余额支付且需要密码，清空对话框密码
                if (pay_method.payMethod === 'balance') {
                    dialogPassword.value = '';
                }

                showPaymentConfirmDialog.value = true;
            };

            // 取消支付选择
            const cancelPaymentSelection = () => {
                showPaymentConfirmDialog.value = false;
                selectedPaymentMethod.value = null;
                dialogPassword.value = '';

                // 确保清除当前选择的支付方式
                current_pay_method.data = {};
                is_show.value = false;

                // 同时清除可能已有的密码
                password.value = '';
            };

            // 确认支付选择
            const confirmPaymentSelection = async () => {
                if (selectedPaymentMethod.value) {
                    // 设置当前支付方式
                    current_pay_method.data = selectedPaymentMethod.value;

                    // 如果是余额支付，设置密码
                    if (selectedPaymentMethod.value.payMethod === 'balance') {
                        if (!dialogPassword.value) {
                            ElMessage.warning('请输入支付密码');
                            return;
                        }
                        password.value = dialogPassword.value;
                    }

                    // 更新显示状态
                    is_show.value = true;
                    unified_show.value = false;
                    zfb_show.value = false;
                    wx_show.value = false;

                    if(selectedPaymentMethod.value.payMethodName === '线下支付'){
                        is_show.value = false;
                    }else if (selectedPaymentMethod.value.payMethodName === '线下合并支付'){
                        is_show.value = false;
                    }else if (selectedPaymentMethod.value.payMethodName === '微信支付'){
                        wx_show.value = true;
                    }else if (selectedPaymentMethod.value.payMethodName === '支付宝'){
                        zfb_show.value = true;
                    }else if (selectedPaymentMethod.value.payMethodName === '多单合并'){
                        unified_show.value = true;
                    }

                    // 立即执行支付
                    const success = await pay(true);

                    // 如果支付成功，则关闭对话框
                    if (success) {
                        showPaymentConfirmDialog.value = false;
                        selectedPaymentMethod.value = null;
                        dialogPassword.value = '';
                    }
                    // 如果支付失败，则保持对话框开启，用户可以重新输入密码或重选
                }
            };
            onUnmounted(() => {
                if (timer.value) {
                    clearInterval(timer.value);
                    timer.value = 0;
                }
            });
            return {
                ElMessageBox,
                ElDialog,
                ElButton,
                 route,
                pay_method,
                balance,
                otherPay,
                ali,
                unified,
                wechat,
                wlian,
                store,
                pay_info,
                current_pay_method,
                balance_list,
                other_pay_list,
                changePayMethod,
                showConfirmDialog,
                cancelPaymentSelection,
                confirmPaymentSelection,
                showPaymentConfirmDialog,
                selectedPaymentMethod,
                dialogPassword,
                buy_name_list,
                password,
                pay,
                wx_pay_tip,
                show_wx_pay,
                hideWxPay,
                refreshWxQrcode,
                wxPayQrImg,
                goRecharge,
                forgetPassword,
                showDetail,
                show_detail,
                show_all_details,
                hasPayMethod,
                configInfo,
                defaultImg,
                memberInfo,
                payComplete,
                is_show,
                zfb_show,
                unified_show,
                wx_show,
                yinlian,
            };
        }
    };
</script>

<style lang="scss">
    @import "../../style/pay.scss";
    @import "../../style/base.scss";
    .red-text {
      color: red;
    }
    .no_payMethod {
        margin: 0 auto;
        width: 1200px;
        height: 560px;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        img {
            width: 163px;
            height: 114px;
        }

        p {
            margin-top: 39px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
        }
    }
    .input_radio{
        display: inline-block;
        width: 20px;
        height: 20px;
        position: relative;
        top: 4px;
    }
</style>
